export default __webpack_public_path__ + "static/media/YAK.ec1f1f43.png";